import React, { memo } from 'react';
import { ScrollArea } from '../../components/ui/scroll-area';
import { Badge } from '../../components/ui/badge';
import { Mail } from 'lucide-react';
import { format } from 'date-fns';

// Memoized Email Card
const EmailCard = memo(({ email, onClick }) => (
  <div 
    className="p-4 border rounded-lg hover:shadow-sm hover:border-blue-200 transition-all cursor-pointer"
    onClick={() => onClick(email)}
    data-testid={`email-card-${email.id}`}
  >
    <div className="flex items-center justify-between mb-2">
      <div className="flex items-center gap-2">
        <Badge variant="outline" className={email.direction === 'outbound' ? 'text-blue-600' : 'text-green-600'}>
          {email.direction === 'outbound' ? 'Sent' : 'Received'}
        </Badge>
        <span className="font-medium">{email.subject}</span>
      </div>
      <span className="text-xs text-muted-foreground">
        {format(new Date(email.created_at), 'MMM d, yyyy')}
      </span>
    </div>
    <p className="text-sm text-muted-foreground line-clamp-2">{email.body}</p>
  </div>
));

EmailCard.displayName = 'EmailCard';

// Main EmailsTab component
const EmailsTab = memo(({ emails, onEmailClick }) => {
  if (emails.length === 0) {
    return (
      <div className="text-center py-12">
        <Mail className="h-12 w-12 text-slate-300 mx-auto mb-3" />
        <p className="text-muted-foreground">No emails logged</p>
      </div>
    );
  }

  return (
    <ScrollArea className="h-[550px]">
      <div className="p-4">
        <div className="space-y-3">
          {emails.map(email => (
            <EmailCard 
              key={email.id} 
              email={email} 
              onClick={onEmailClick}
            />
          ))}
        </div>
      </div>
    </ScrollArea>
  );
});

EmailsTab.displayName = 'EmailsTab';

export default EmailsTab;
